import { axios } from "utils/axios";
import API from "../base/base";

const Sessions = new API({ controller: "sessions" });

Object.assign(Sessions, {
  logout() {
    return axios.delete(`${this.url}/logout`);
  },
});

export default Sessions;
